import Vue from 'vue';
const config = token => ({ headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } });
export async function listarRegistrosViajeros(token, reservaId) {
  const response = await Vue.axios.get(`/reservas/${reservaId}/registros-viajeros`, config(token));
  return response.data.data;
}
export async function enviarDocumentosPasajeros(token, reservaId, pasajeros, correo) {
  const response = await Vue.axios.post(`/reservas/${reservaId}/registros-viajeros/enviar`, { pasajeros, correo }, config(token));
  return response.data;
}
